// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum EntryFlowType {
    SPIRAL,
    GRID

}
export default EntryFlowType
